export type FileRouteConfig = {
  endpoint: string;
  showInfoNote?: boolean;
  noteMessage?: string;
};

export const FILE_UPLOAD_CONFIG: Record<string, FileRouteConfig> = {
  ".wav": {
    endpoint: "WMS/Alpha",
    showInfoNote: true,
    noteMessage: "WAV files will be processed via WMS/Alpha service.",
  },
  ".mp3": {
    endpoint: "WMS/Alpha",
    showInfoNote: true,
    noteMessage: "MP3 files will be processed WMS/Alpha Endpoint.",
  },
  ".m4a": {
    endpoint: "WMS/Alpha",
    showInfoNote: true,
    noteMessage: "MPA files will be processed WMS/Alpha Endpoint.",
  },
  ".aac": {
    endpoint: "WMS/Alpha",
    showInfoNote: true,
    noteMessage: "AAC files will be processed WMS/Alpha Endpoint.",
  },
  ".aiff": {
    endpoint: "WMS/Alpha",
    showInfoNote: true,
    noteMessage: "AIFF files will be processed WMS/Alpha Endpoint.",
  },
  ".flac": {
    endpoint: "WMS/Alpha",
    showInfoNote: true,
    noteMessage: "FLAC files will be processed via WMS/Alpha Endpoint.",
  },
  ".ogg": {
    endpoint: "WMS/Alpha",
    showInfoNote: true,
    noteMessage: "OGG files will be processed WMS/Alpha Endpoint.",
  },
  ".opus": {
    endpoint: "WMS/Alpha",
    showInfoNote: true,
    noteMessage: "OPUS files will be processed WMS/Alpha Endpoint.",
  },
  ".mp4": {
    endpoint: "WMS/Alpha",
    showInfoNote: true,
    noteMessage: "MP4 files will be processed WMS/Alpha Endpoint.",
  },
  ".mov": {
    endpoint: "WMS/Alpha",
    showInfoNote: true,
    noteMessage: "MOV files will be processed WMS/Alpha Endpoint.",
  },
  ".webm": {
    endpoint: "WMS/Alpha",
    showInfoNote: true,
    noteMessage: "WEBM files will be processed WMS/Alpha Endpoint.",
  },
  ".m4v": {
    endpoint: "WMS/Alpha",
    showInfoNote: true,
    noteMessage: "M4V files will be processed WMS/Alpha Endpoint.",
  },
  ".mkv": {
    endpoint: "WMS/Alpha",
    showInfoNote: true,
    noteMessage: "MKV files will be processed WMS/Alpha Endpoint.",
  },
};
